export default {
      id: "reefer-info-4-usage",
      viewBox: "0 0 27 34",
      url: __webpack_public_path__ + "img/icons.svg#reefer-info-4",
      toString: function () {
        return this.url;
      }
    }